import * as React from 'react';

export const User = React.createContext({});
